import React from 'react';
import { ProcessedSection } from '../sectionProcessing';
import { renderVideoBlockContent } from './renderers/SitePageVideoBlock';
import { renderTableBlockContent } from './renderers/SitePageTableBlock';
import { renderRichTableBlockContent } from './renderers/SitePageRichTableBlock';
import { renderInternalLinkBlockContent } from './renderers/SitePageInternalLinkBlock';
import { renderImageBlockContent } from './renderers/SitePageImageBlock';
import { SitePageHtmlContent } from './SitePageHtmlContent';

export function renderSectionContent(section: ProcessedSection): React.ReactNode {
    if (section.kind === 'imageBlock') {
        return renderImageBlockContent(section);
    }

    if (section.kind === 'videoBlock') {
        return renderVideoBlockContent(section);
    }

    if (section.kind === 'tableBlock') {
        return renderTableBlockContent(section);
    }

    if (section.kind === 'richTableBlock') {
        return renderRichTableBlockContent(section);
    }

    if (section.kind === 'internalLinkBlock') {
        return renderInternalLinkBlockContent(section);
    }

    if (section.kind === 'headingSection') {
        return null;
    }

    if (section.sanitizedRichText && section.sanitizedRichText.trim().length > 0) {
        return <SitePageHtmlContent html={section.sanitizedRichText} as="div" />;
    }

    if (section.plainTextParagraphs && section.plainTextParagraphs.length > 0) {
        return section.plainTextParagraphs.map((paragraph, idx) => (
            <p key={`paragraph-${idx}`}>{paragraph}</p>
        ));
    }

    return null;
}
